import { TextSecondary } from '@cycle-app/ui';
import { CloseIcon } from '@cycle-app/ui/icons';

import { setUpgradeModal, useGetUpgradeModal } from '../../reactives/upgradeModal.reactive';
import {
  StyledPortalModal, Container, Title, StyledFeatures, RightBox, RightBoxHeader, RightBoxBody, StyledActionButton,
} from './UpgradeModal.styles';
import { UpgradeModalAddons } from './UpgradeModalAddons';
import { UpgradeModalForm } from './UpgradeModalForm';
import { UpgradeModalFormMakers } from './UpgradeModalFormMakers';

export const UpgradeModal = () => {
  const { isOpened } = useGetUpgradeModal();
  return isOpened ? (
    <UpgradeModalContent />
  ) : null;
};

const UpgradeModalContent = () => {
  return (
    <StyledPortalModal
      hide={() => setUpgradeModal({ isOpened: false })}
    >
      <StyledActionButton onClick={() => setUpgradeModal({ isOpened: false })}>
        <CloseIcon />
      </StyledActionButton>
      <Title>Upgrade to go further</Title>
      <Container>
        <div>
          <TextSecondary>
            Cycle is the fastest way for your team to capture product feedback and share customer insights – without the busywork.
          </TextSecondary>
          <StyledFeatures tooltip />
        </div>
        <div>
          <RightBox>
            <RightBoxHeader>
              <div>
                <UpgradeModalAddons />
              </div>
              <div>
                <UpgradeModalFormMakers />
              </div>
            </RightBoxHeader>
            <RightBoxBody>
              <UpgradeModalForm />
            </RightBoxBody>
          </RightBox>
        </div>
      </Container>
    </StyledPortalModal>
  );
};
